import { IMucThuTamThuSinhVienSelectRequest } from "../../model/request/chung-tu-tam-thu/IMucThuTamThuSinhVienSelectRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_TAM_THU_SINH_VIEN = "muc-thu-tam-thu-sinh-vien";
export const mucThuTamThuSinhVienApi = {
  SelectBySinhVien: (request: IMucThuTamThuSinhVienSelectRequest) =>
    apiClient.post(`${MUC_THU_TAM_THU_SINH_VIEN}/select-by-sinhvien`, request),
  GetSoTienConLaiBySinhVien: (request: IMucThuTamThuSinhVienSelectRequest) =>
    apiClient.post(
      `${MUC_THU_TAM_THU_SINH_VIEN}/get-sotienconlai-by-sinhvien`,
      request
    ),
};
